/* global axios */

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs = window.location.pathname.includes(
      '/app/accounts'
    );

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.enterprise) {
      url = `/enterprise${url}`;
    } else if (this.options.kedu) {
      url = `/kedu${url}`;
    }

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    // Avoid adding an extra slash when id is empty/falsy
    const url = id ? `${this.url}/${id}` : this.url;
    return axios.patch(url, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getAgentsWithReasonLabel(){
    return axios.get(`${this.url}/agents_with_reason_label`);
  }

  contract(data) {
    const id = data['id'];
    return axios.post(`${this.url}/${id}/contract`, data);
  }

  getContracts(id) {
    return axios.get(`${this.url}/${id}/get_contract`);
  }
}

export default ApiClient;
